import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A stunning collection of fine art pieces available for sale" 
          className="hero-image" 
        />
        <p className="eyebrow">McMahon Fine Art</p>
        <h1>Discover Timeless Artistry</h1>
        <p className="lede">
          Explore our curated online gallery featuring exquisite fine art pieces from talented artists around the world. 
          Each artwork tells a unique story, waiting to be part of your collection.
        </p>
        <div className="cta-row">
          <a href="/gallery" className="primary">
            View Gallery
          </a>
          <a href="/about" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Curated Collections</h2>
          <p>
            Browse through our carefully selected collections that showcase the best in contemporary and classic art.
          </p>
        </article>
        <article>
          <h2>Support Artists</h2>
          <p>
            Every purchase supports the artists behind the works, helping to foster creativity and innovation in the art community.
          </p>
        </article>
        <article>
          <h2>Art for Every Space</h2>
          <p>
            Whether you're looking for a statement piece or something subtle, our diverse range of artworks fits any aesthetic.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;